// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var React       = require("react");
var Subtitle    = require("./Subtitle");
var HistoryItem = require("./HistoryItem");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./PreviousMeals.css')));

function str(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Previous Meals");

function make(meals, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "History"
                }, ReasonReact.element(/* None */0, /* None */0, Subtitle.make("History", /* array */[])), React.createElement("ul", {
                      className: "History-items"
                    }, $$Array.of_list(List.map((function (meal) {
                                return ReasonReact.element(/* Some */[meal.id], /* None */0, HistoryItem.make(meal.name, meal.timestamp, meal.categories, /* array */[]));
                              }), meals))));
    });
  return newrecord;
}

exports.str       = str;
exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/PreviousMeals.re
// module id = 382
// module chunks = 0